export enum ConsentType {
  PRIVACY_POLICY = 'privacy-policy',
  PIPL = 'pipl-policy',
}
